import useCachedList from '../base/useCachedList';
import useFindCrewListLazy from './useFindCrewList';
import UserCrewMemberListItemDTO from '@src/adapters/dto/user/UserCrewMemberListItemDTO';

type FindLazyResult = { members: UserCrewMemberListItemDTO[] };

const useCachedUserList = () => {
  return useCachedList<UserCrewMemberListItemDTO, FindLazyResult>(
    'crewList',
    useFindCrewListLazy,
    'members'
  );
};

export default useCachedUserList;
